module.exports = __webpack_public_path__ + "img/streakMobile.0bb33a44.svg";